import { ContentfulHealthDetailsSection } from 'ContentfulDefaults/types/healthDetails';

export const healthDetails: {
  health_details_section: ContentfulHealthDetailsSection;
} = {
  health_details_section: {
    previous_page_button_text: 'All Health Plans',
    eligibility_notice: {
      name: '[DEFAULT] Eligibility Notice',
      button_text: 'Learn More',
      hsa: {
        data: {},
        content: [
          {
            data: {},
            content: [
              { data: {}, marks: [], value: 'This plan is ', nodeType: 'text' },
              {
                data: {},
                marks: [{ type: 'bold' }],
                value: 'HSA-eligible',
                nodeType: 'text',
              },
              { data: {}, marks: [], value: '.', nodeType: 'text' },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      hsa_contribution: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            data: {},
            content: [
              {
                nodeType: 'text',
                value: 'If you pick this HSA-eligible health plan, your employer will contribute ',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [{ type: 'code' }, { type: 'bold' }],
                data: {},
              },
              {
                nodeType: 'text',
                value: ' to your HSA',
                marks: [{ type: 'bold' }],
                data: {},
              },
              { nodeType: 'text', value: '.', marks: [], data: {} },
            ],
          },
        ],
      },
      hsa_match: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'If you pick this HSA Eligible health plan, your employer will\u00a0',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [{ type: 'bold' }],
                value: 'match ',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [{ type: 'code' }, { type: 'bold' }],
                value: '{x}',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [{ type: 'bold' }],
                value: '% (up to ',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [{ type: 'code' }, { type: 'bold' }],
                value: '{x}',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [{ type: 'bold' }],
                value: ') of your contributions',
                nodeType: 'text',
              },
              { data: {}, marks: [], value: '.', nodeType: 'text' },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      hra: {
        data: {},
        content: [
          {
            data: {},
            content: [
              { data: {}, marks: [], value: 'This plan is ', nodeType: 'text' },
              {
                data: {},
                marks: [{ type: 'bold' }],
                value: 'HRA-eligible',
                nodeType: 'text',
              },
              { data: {}, marks: [], value: '.', nodeType: 'text' },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      hra_contribution: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'If you pick this HRA-eligible health plan, your employer will contribute ',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [{ type: 'code' }, { type: 'bold' }],
                value: '{x}',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [{ type: 'bold' }],
                value: ' to your HRA',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [],
                value: '.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      fsa: {
        data: {},
        content: [
          {
            data: {},
            content: [
              { data: {}, marks: [], value: 'This plan is ', nodeType: 'text' },
              {
                data: {},
                marks: [{ type: 'bold' }],
                value: 'FSA-eligible',
                nodeType: 'text',
              },
              { data: {}, marks: [], value: '.', nodeType: 'text' },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      fsa_contribution: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'If you pick this FSA-eligible health plan, your employer will contribute ',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [{ type: 'code' }, { type: 'bold' }],
                value: '{x}',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [{ type: 'bold' }],
                value: ' to your FSA',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [],
                value: '.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      sihra: {
        data: {},
        content: [
          {
            data: {},
            content: [
              { data: {}, marks: [], value: 'This plan is ', nodeType: 'text' },
              {
                data: {},
                marks: [{ type: 'bold' }],
                value: 'SIHRA-eligible',
                nodeType: 'text',
              },
              { data: {}, marks: [], value: '.', nodeType: 'text' },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      sihra_contribution: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'If you pick this plan your employer will contribute ',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [{ type: 'bold' }],
                value: 'up to ',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [{ type: 'code' }, { type: 'bold' }],
                value: '{x}',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [{ type: 'bold' }],
                value: ' to your SIHRA',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [],
                value: '.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    plan_eligibility: {
      title: 'Eligible',
      subtitle: 'This plan is',
      buttonText: 'Learn More',
    },
    plan_eligibility_footnote: [
      {
        contentful_name: '[DEFAULT] Health Details Section - Plan Eligibility Footnote - Garner HRA',
        message_id: 'health_details_plan_eligibility_footnote_garner_hra',
        text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'when you get care from a Garner Top Provider',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
      },
      {
        contentful_name: '[DEFAULT] Health Details Section - Plan Eligibility Footnote - HSA + Post-Ded HRA',
        message_id: 'health_details_plan_eligibility_footnote_hsa_post_ded_hra',
        text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              data: {},
              content: [
                {
                  nodeType: 'text',
                  value: 'and ',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: 'HRA eligible',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: ', after you’ve spent ',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '{x}',
                  marks: [
                    {
                      type: 'code',
                    },
                  ],
                  data: {},
                },
              ],
            },
          ],
        },
      },
    ],
    plan_details: {
      name: '[DEFAULT] Plan Details',
      plan_essentials_card_title: 'Plan Essentials',
      prescriptions_card_title: 'Prescriptions',
      doctor_visits_card_title: 'Doctor Visits',
      doctors_providers_card_title: 'Doctors & Providers',
      breakdown_tag_tier1_deductible: 'Tier 1',
      breakdown_tag_tier2_deductible: 'Tier 2',
      prescription_cost_not_covered_text: 'Not Covered',
    },
    cta_pdf_header_text: 'Looking for all of the plan details?',
    cta_provider_header_text: 'Is my doctor or network provider available?',
    after_deductible: 'after deductible is met',
    rx_tiers_static_values: {
      retail: 'Retail (30-day supply)',
      rx_tiers: {
        tier_1: 'Tier 1 Rx',
        tier_2: 'Tier 2 Rx',
        tier_3: 'Tier 3 Rx',
        tier_4: 'Tier 4 Rx',
        tier_5: 'Tier 5 Rx',
      },
      mail_order: 'Mail Order (90-day supply)',
      no_coverage: 'Not Covered',
      coverage_heading: 'PRESCRIPTION COVERAGE',
      deductible_waived: 'Deductible waived',
      after_deductible: 'After Deductible',
      retail_text: 'Retail',
      mail_order_text: 'Mail Order',
    },
    rx_copay: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'You pay a ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ' copay',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    rx_coinsurance: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'You pay ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    rx_coinsurance_with_limits_having_min_max: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'You pay ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ' (minimum limit : ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ', maximum limit : ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ')',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    rx_coinsurance_with_limits_without_max: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'You pay ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ' (minimum limit : ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ')',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    rx_coinsurance_with_limits_without_min: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'You pay ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ' (maximum limit : ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ')',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    rx_copay_then_coinsurance: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'You pay a ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ' copay, then you pay ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
  },
};
